/**
 * Labstep
 *
 * @module components/Entity/Action/Tag/Bulk
 * @desc Action to tag entity in bulk
 */

import { EntityActionAddSearchBulkContainer as EntityActionAddSearchBulk } from 'labstep-web/components/Entity/Action/AddSearch/Bulk';
import { useHasAccessMultiple } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { ICONS } from 'labstep-web/constants/icons';
import type { TopLevelPermissionEntity } from 'labstep-web/models';
import { Tag } from 'labstep-web/models/tag.model';
import type React from 'react';
import type { EntityActionTagBulkProps } from './types';

export const EntityActionTagBulk: React.FC<
  EntityActionTagBulkProps
> = ({ entityName, parentEntities, options }) => {
  const parentEntityIdsAccessObject = useHasAccessMultiple(
    entityName,
    parentEntities ? parentEntities.map((e) => e.id) : [],
    Action.tag_add_remove,
  );

  const parentEntitiesWithPermission = parentEntities
    ? parentEntities.filter((e) => parentEntityIdsAccessObject[e.id])
    : [];

  if (
    !parentEntities ||
    parentEntities.length === 0 ||
    parentEntitiesWithPermission.length === 0
  ) {
    return null;
  }

  return (
    <EntityActionAddSearchBulk
      dataCy="components/Entity/Action/Tag/Bulk"
      entityName={Tag.entityName}
      parentEntities={parentEntities}
      parentEntitiesWithPermission={
        parentEntitiesWithPermission as TopLevelPermissionEntity[]
      }
      actionText={'Add Tags'}
      icon={ICONS.entity.actions.tag}
      options={options}
    />
  );
};
